import api from './api';

const sliderService = {
  // Get all active sliders
  getSliders: async () => {
    try {
      const response = await api.get('/store/sliders');
      return response.data;
    } catch (error) {
      console.error('Error fetching sliders:', error);
      throw error;
    }
  },
};

export default sliderService;
